import styled, { css } from 'styled-components/macro'
import { Overlay, styleReset } from 'styles/misc'
import { theme } from 'styles/theme'

export const Container = styled.div<{ $isCollapsed: boolean }>`
  position: relative;
  aspect-ratio: 16 / 9;
  color: ${theme.colors.text};
  transition: 0.4s aspect-ratio, 0.4s margin-bottom;
  overflow: hidden;
  margin: 3rem 0;

  button,
  img,
  iframe {
    ${styleReset}
    ${Overlay}
    object-fit: cover;
    object-position: center top;
  }

  button {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 28.125%;
    cursor: pointer;
  }

  svg {
    position: relative;
    display: block;
    width: clamp(2rem, 11%, 9rem);
    transform: translateY(-50%);
  }

  button:hover {
    path {
      color: ${theme.colors.background};
    }

    circle {
      fill: currentColor;
    }
  }

  ${props =>
    props.$isCollapsed &&
    css`
      aspect-ratio: 160 / 57;
      margin-bottom: 0;
    `}
`
